
import React, {FC} from 'react';
import {ApptProps} from 'components/ApptDetails2';
import {createReserveAppt} from 'components/checkout/setup';
import {useContextHolder} from 'components/useHolder/context';
import {ConfigProvider, PriceConfig} from 'pages/pricing-packages/components/context';
import TabsMobile from 'pages/pricing-packages/components/TabsMobile';
import {createSuccessLink} from 'templates/booking/Success/useSuccess';

import * as styles from './styles.module.scss';
type PricingProps = {
	appt: ApptProps
}

const Pricing: FC<PricingProps> = ({appt}) => {
	const holder = useContextHolder();

	const config: PriceConfig = {
		modal: true,
		setup: ({interval, quantity}) => createReserveAppt({
			appt: appt.id,
			hold: holder.id,
			interval,
			quantity,
			redirect: createSuccessLink(),
		}),
	};

	return (
		<ConfigProvider config={config}>
			<div className={styles.pricing}>
				<TabsMobile />
			</div>
		</ConfigProvider>
	);
};

export default Pricing;
